import { Button } from "@/components/ui/button";
import { ArrowLeft, Home } from "lucide-react";

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-offwhite p-6 font-body">
      <div className="max-w-md w-full text-center space-y-8 animate-in fade-in zoom-in-95 duration-500">
        
        {/* Logo */}
        <div className="flex justify-center mb-12">
          <img 
            src="https://res.cloudinary.com/tatikka/image/upload/v1774976999/Logo_Simples_f4nl6q.svg" 
            alt="Tavares & Camilo" 
            className="h-12 w-auto opacity-80"
          />
        </div>

        {/* 404 Visual */}
        <div className="relative">
          <h1 className="text-9xl font-heading font-black text-primary/5 select-none">
            404
          </h1>
          <div className="absolute inset-0 flex items-center justify-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-navy">
              Caminho não encontrado
            </h2>
          </div>
        </div>

        <p className="text-muted-foreground leading-relaxed max-w-sm mx-auto">
          Parece que você seguiu um link que não existe ou a página foi movida. Não se preocupe, estamos aqui para ajudar você a voltar ao caminho certo.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
          <a href="/">
            <Button variant="hero" className="w-full sm:w-auto h-12 px-8 rounded-xl shadow-soft gap-2">
              <Home size={18} />
              Voltar para a Home
            </Button>
          </a>
          <button onClick={() => window.history.back()}>
            <Button variant="outline" className="w-full sm:w-auto h-12 px-8 rounded-xl border-navy/10 text-navy hover:bg-navy/5 gap-2">
              <ArrowLeft size={18} />
              Voltar página
            </Button>
          </button>
        </div>

        <div className="pt-12 text-xs text-muted-foreground/60">
          © {new Date().getFullYear()} Tavares & Camilo
        </div>
      </div>
    </div>
  );
};

export default NotFound;
